var m = require('mithril');
var Model = require('../../libs/Model');
var animations = require('../../libs/animations');
var formGroup = require('../../components/formGroup');
var discoveryModal = require('../discoveryModal');

var ltDevice = Object.create(Model);
  
ltDevice.name = 'Lontalk Device';
ltDevice.url = 'lontalkdevice';
ltDevice['@class'] = 'LontalkDevice';

ltDevice.actions = [
  {
    name: 'Discover',
    func: function (ctrl) {
      return discoveryModal.open(ctrl.record, ctrl.init);
    }
  }
];

ltDevice.fields = {
  parent: {
    hidden: true
  },
  name: {
    type: 'string',
    default: '',
    validators: {
      presence : true, 
      length: {minimum: 3, maximum: 128, default: ''},
    }
  },
  domain: {
    type: 'number',
    validators: {
      presence: true,
    }
  },
  subnet: {
    type: 'number',
    default: 1,
    validators: {
      presence: true,
      numericality: {
        onlyInteger: true,
        greaterThan: 0,
        lessThanOrEqualTo: 256
      }
    }
  },
  node: {
    type: 'number',
    default: 1,
    validators: {
      presence: true,
      numericality: {
        onlyInteger: true,
        greaterThan: 0,
        lessThanOrEqualTo: 256
      }
    }
  },
  programId: {
    type: 'string',
    validators: {}
  },
  neuronId: {
    type: 'string',
    validators: {}
  },
  locationId: {
    type: 'string',
    validators: {}
  },
  eesPath: {
    type: 'string',
    validators: {}
  },
};

ltDevice.initForm();

ltDevice.view = function () { 
  return  m('form', {role:'form'}, [
    ltDevice.errorView(),
    m(formGroup, [
      m('label', {for:'name-input'}, 'Name'),
      m('input.form-control', {
        id:'name-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){ltDevice.form.name(ev.target.value)},
        value: ltDevice.form.name(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'domain-input'}, 'Domain'),
      m('input.form-control', {
        id:'domain-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){ltDevice.form.domain(ev.target.value)}, 
        value: ltDevice.form.domain(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'subnet-input'}, 'Subnet'),
      m('input.form-control', {
        id:'subnet-input', 
        autocomplete: 'off',
        type:'number', 
        onchange: function(ev){ltDevice.form.subnet(ev.target.value)},
        value: ltDevice.form.subnet(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'node-input'}, 'Node'),
      m('input.form-control', {
        id:'node-input', 
        autocomplete: 'off',
        type:'number', 
        onchange: function(ev){ltDevice.form.node(ev.target.value)},
        value: ltDevice.form.node(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'programId-input'}, 'Program ID'),
      m('input.form-control', {
        id:'programId-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){ltDevice.form.programId(ev.target.value)},
        value: ltDevice.form.programId(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'neuronId-input'}, 'Neuron ID'),
      m('input.form-control', {
        id:'neuronId-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){ltDevice.form.neuronId(ev.target.value)},
        value: ltDevice.form.neuronId(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'locationId-input'}, 'Location ID'),
      m('input.form-control', {
        id:'locationId-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){ltDevice.form.locationId(ev.target.value)},
        value: ltDevice.form.locationId(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'eesPath-input'}, 'EES Path'),
      m('input.form-control', {
        id:'eesPath-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){ltDevice.form.eesPath(ev.target.value)},
        value: ltDevice.form.eesPath(),
      })
    ]),
  ])
}

module.exports = ltDevice;
